/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useAtomValue } from "jotai";

import type { OrderQuery } from "~/graphql/graphql-new.gen";
import { brandState } from "~/stores/brand";

import { OrderShopifyDesyncAlert } from "./order-shopify-desync-alert";
import { OrderShopifyNotConfiguredAlert } from "./order-shopify-not-configured-alert";

type OrderShopifyProps = {
  order?: OrderQuery["order"];
};

export const OrderShopify: React.FC<OrderShopifyProps> = ({ order }) => {
  const brand = useAtomValue(brandState);

  if (brand?.plugins?.shopify && !brand.plugins.shopify.token) {
    return <OrderShopifyNotConfiguredAlert />;
  }
  if (brand?.plugins?.shopify && order?.integration.errorMessage) {
    return (
      <OrderShopifyDesyncAlert
        exportedErrorCode={order.integration.errorMessage}
        fulfillment={order.tags.fulfillment}
      />
    );
  }
  return null;
};
